import { runInAction } from "mobx";
import { APIClient } from "Application";
import toast from "react-hot-toast";

import { MentorAbsenceViewModel } from "../MentorAbsenceViewModel";
import { GETMentorsEndpoint, MentorResponse } from "../EndPoints/GETMentorsEndpoint";
import { POSTMentorAbsenceEndPoint, POSTMentorAbsenceRequest } from "../EndPoints/POSTMentorAbsenceEndPoint";
import { WeeklyRotaDetailsViewModel } from "../../WeeklyRotaDetailViewModel";

export class APIManager {
    public apiClient = new APIClient();

    constructor(private viewModel: MentorAbsenceViewModel) {}

    /** Loads the mentor list. Call from initialize(), not from constructor. */
    public async loadMentors(): Promise<void> {
        await this.apiClient.sendAsync(new GETMentorsEndpoint());
        if (this.apiClient.IsRequestSuccessful) {
            const responses = this.apiClient.Response<MentorResponse[]>() ?? [];
            runInAction(() => {
                if (responses.length > 0) {
                    this.viewModel.model.mentors.replace(responses);
                }
            });
        }
    }

    /**
     * Saves the mentor absence.
     * On success, sets _submittedSuccessfully which the view observes to close itself.
     */
    public async addMentorAbsence(parentViewModel: WeeklyRotaDetailsViewModel): Promise<void> {
        if (!this.viewModel.canSubmitForm) return;

        runInAction(() => {
            this.viewModel.model.rotaId = parentViewModel.model.rotaId;
            parentViewModel.managers.mobx.setSuccessfullyGetWeeklyRota(false);
        });

        // Build request (moved from POSTMentorAbsenceEndPoint.HandleRequestAsync)
        const request: POSTMentorAbsenceRequest = {
            rotaId: this.viewModel.model.rotaId,
            mentorId: this.viewModel.model.mentorId,
            absenseStartDate: this.viewModel.model.absenceStartDate + "T" + this.viewModel.model.absenceShiftAM,
            absenseEndDate: this.viewModel.model.absenceEndDate + "T" + this.viewModel.model.absenceShiftPM,
        };

        await this.apiClient.sendAsync(new POSTMentorAbsenceEndPoint(), request);

        if (this.apiClient.IsRequestSuccessful) {
            await parentViewModel.managers.api.getRotaByDateAsync(false);
            runInAction(() => {
                parentViewModel.managers.mobx.setSuccessfullyGetWeeklyRota(true);
                this.viewModel.managers.mobx.setSubmittedSuccessfully(true);
            });
        } else {
            toast.error(this.apiClient.ValidationMessage, {
                position: "top-right",
                style: { marginTop: "45px" },
            });
        }
    }
}
